import { render, staticRenderFns } from "./ServiceAvailableAlertSection.vue?vue&type=template&id=88a1d030&scoped=true&"
import script from "./ServiceAvailableAlertSection.vue?vue&type=script&lang=js&"
export * from "./ServiceAvailableAlertSection.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAvailableAlertSection.vue?vue&type=style&index=0&id=88a1d030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a1d030",
  null
  
)

export default component.exports